import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    t: "Location",
    d: "Mansampalle, Vikarabad district, Telangana — well placed for Hyderabad wholesale traders and regional distributors.",
    id: "info-chapter-location",
  },
  {
    n: "02",
    t: "Eggs & Packaging",
    d: "Farm-fresh white eggs, hygienically packed in standard trays and bulk crates for safe transit.",
    id: "info-chapter-product",
  },
  {
    n: "03",
    t: "Daily Rates",
    d: "Egg prices move daily with the market. Call or WhatsApp us for today's wholesale rate per tray or crate.",
    id: "info-chapter-pricing",
  },
];

const Chapters = () => (
  <section data-testid="chapters-section" className="mx-auto max-w-6xl px-5 py-16 lg:py-20">
    <motion.p
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6 }}
      className="mb-8 font-mono-brand text-xs font-semibold uppercase tracking-[0.24em] text-[#C5A059]"
    >
      The Essentials
    </motion.p>
    <div>
      {CHAPTERS.map((c, i) => (
        <motion.div
          key={c.n}
          data-testid={c.id}
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.65, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          className="grid gap-2 border-t border-[#E8DFC8] py-7 last:border-b sm:grid-cols-[80px_220px_1fr] sm:items-baseline sm:gap-6"
        >
          <span className="font-mono-brand text-sm font-semibold text-[#C5A059]">{c.n}</span>
          <h3 className="font-display text-lg font-semibold text-[#6B1D2F] sm:text-xl">{c.t}</h3>
          <p className="text-sm leading-relaxed text-[#5C4A42] sm:text-base">{c.d}</p>
        </motion.div>
      ))}
    </div>
  </section>
);

export default Chapters;
